import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../../../../../../util/assets';
import Badge from '../../../../../../../../../components/global/Badge';
import PriceDisplay from '../../../../../../../../../components/global/PriceDisplay';
import Button from '../../../../../../../../../components/global/Button';
import AddedToCartLabel from '../../../PhotoPurchasingOptions/AddedToCartLabel';
import { getIdentityCallingName } from '../../helpers';
import { getAlbumFolderSubscriptionCartItemPrice } from '../../../../../../../../../services/checkout/redux/helpers';
import PrintPackageContentsModal from './PrintPackageContentsModal';

const propTypes = {
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  subscriptionItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  albumPrintPackage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    print_package: PropTypes.shape({
      id: PropTypes.string.isRequired,
      price: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
      discount_price: PropTypes.shape({
        value: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  onBundleToggle: PropTypes.func.isRequired,
  inCart: PropTypes.bool,
};

const AlbumPrintPackageSubscriptionBundleOption = ({
  className,
  readOnly,
  identity,
  albumPrintPackage,
  subscriptionItem,
  onBundleToggle,
  inCart,
}) => {
  const classes = classNames({
    [className]: !!className,
    'purchasing-option-item': true,
    'purchasing-option-item-album-print-package-bundle': true,
    'is-selected': inCart,
  });
  const [
    printPackageContentsModalOpen,
    setPrintPackageContentsModalOpen,
  ] = useState(false);
  const identityName = identity ? getIdentityCallingName(identity) : '';
  const printPackage = albumPrintPackage.print_package;
  const printPackagePrice = printPackage.price.value;
  const printPackageDiscountPrice = printPackage.discount_price.value;
  const subscriptionPrice =
    getAlbumFolderSubscriptionCartItemPrice({ albumFolder: subscriptionItem })
      ?.value || subscriptionItem.price_whole_album?.value;
  const oldPrice = subscriptionPrice + printPackagePrice;
  const finalPrice = subscriptionPrice + printPackageDiscountPrice;

  return (
    <div className={classes}>
      <div className="purchasing-option-item-thumb">
        <img src={getAsset('/print-package-combo.svg')} alt="" />
      </div>

      <div className="purchasing-option-item-content-wrap">
        <span className="purchasing-option-item-title">
          Digital Photo Pass + {printPackage.name}
        </span>
        <div className="purchasing-option-item-info-extra">
          <Badge badgeStyle="yellow" className="text-extra-bold">
            <PriceDisplay
              title="Bundle price"
              price={finalPrice}
              oldPrice={oldPrice}
              showDiscount
              animatedStrikethrough
            />
          </Badge>
        </div>

        <div className="purchasing-option-item-content">
          {readOnly ? (
            <p className="text-sm lh-normal text-dark text-bold">
              <strong>All photos</strong> from {subscriptionItem.name} plus{' '}
              {printPackage.name}!
            </p>
          ) : (
            <p className="text-sm lh-normal text-dark text-bold">
              <strong>All {identityName} photos</strong> from{' '}
              {subscriptionItem.name} plus {printPackage.name}!
            </p>
          )}

          <p className="text-sm lh-normal text-dark text-bold">
            <Button
              btnStyle="link"
              className="text-sm lh-normal text-extra-bold"
              onClick={() => setPrintPackageContentsModalOpen(true)}
            >
              See Print Package contents
            </Button>
          </p>
        </div>

        {!readOnly && (
          <div className="purchasing-option-item-actions">
            <Button
              btnStyle={classNames({
                primary: !inCart,
                info: inCart,
              })}
              className={classNames({
                'purchasing-options-item-btn': true,
                'btn-purchase-options-in-cart': inCart,
              })}
              onClick={onBundleToggle}
              data-testid="btn-album-print-package-bundle-subscription"
            >
              {inCart ? <AddedToCartLabel /> : <Fragment>Add to cart</Fragment>}
            </Button>
          </div>
        )}

        <PrintPackageContentsModal
          forceOpen={printPackageContentsModalOpen}
          albumPrintPackage={albumPrintPackage}
          onClose={() => setPrintPackageContentsModalOpen(false)}
          subscriptionItem={subscriptionItem}
        />
      </div>
    </div>
  );
};

AlbumPrintPackageSubscriptionBundleOption.propTypes = propTypes;

export default AlbumPrintPackageSubscriptionBundleOption;
